import React from "react";
import { TextField } from "@mui/material";
import styles from "./index.module.css";

const Input = ({ className = "", ...props }) => {
  return (
    <TextField
      className={`${styles.textField} ${className}`}
      fullWidth={props.fullWidth !== undefined ? props.fullWidth : true}
      {...props}
    />
  );
};

export default Input;
